import RetargetingListList from 'common/pages/retargeting-list/RetargetingListList'

export const RetargetingListListAgency = (props) => <RetargetingListList {...props} agency />
